import type { MoveMethod, FadeMethod } from "../../types";
import type { Easing } from "motion/react";

/**
 * Maps our MoveMethod/FadeMethod enums to Framer Motion easing values.
 * Uses cubic bezier arrays for precise control.
 */
const EASING_MAP: Record<MoveMethod | FadeMethod, Easing> = {
  Linear: [0, 0, 1, 1],
  EaseInOut: [0.42, 0, 0.58, 1],
  Elastic: [0.68, -0.55, 0.265, 1.55],
  Exponential: [0.7, 0, 0.84, 0],
  Bounce: [0.34, 1.56, 0.64, 1],
  EaseInOutExpo: [0.87, 0, 0.13, 1],
  EaseInOutQuint: [0.83, 0, 0.17, 1],
};

export const getMotionEasing = (method?: MoveMethod | FadeMethod): Easing => {
  if (!method) return EASING_MAP.EaseInOut;
  return EASING_MAP[method];
};
